module.exports = __webpack_public_path__ + "img/proveedores.ce1c76ad.svg";